import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { systemEvaluationMetricsView, systemSubjects, systemAcademicAssignmentsView, systemAreasView, AcademicAssignmentEdit } = Views;

const academicRouter = {
  path: "/academic",
  component: Layout,
  redirect: "dashboard",
  name: "",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "system-evaluation-metrics",
      name: "SystemEvaluationMetrics",
      component: systemEvaluationMetricsView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "system-subjects",
      name: "SystemSubjects",
      component: systemSubjects,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "academic-assignments",
      name: "SystemAcademicAssignments",
      component: systemAcademicAssignmentsView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "academic-assignments-edit/:id",
      name: "AcademicAssignmentsEdit",
      component: AcademicAssignmentEdit,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "areas",
      name: "SystemAreas",
      component: systemAreasView,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default academicRouter;
